import Fingerprint2 from 'fingerprintjs2'
import axios from 'axios'

export default {
  name: 'Playground',
  data: function () {
    return {
      type: 'none',
      nativeEventsWoPrevent: 'none',
      nativeEventsWithPrevent: 'none',
      number: 0
    }
  },
  mounted() {
    this.generateFingerprint()
  },
  methods: {
    generateFingerprint() {
      var options = {
        fonts: {
          extendedJsFonts: true
        },
        excludes: {
          // https://github.com/fingerprintjs/fingerprintjs2/wiki/Stable-components
          canvas: true,
          webgl: true,
          hardwareConcurrency: true,
          adBlock: true,
          fonts: true,
          // userAgent: true,
          // audio: true,
          // customEntropyFunction: true,
          // plugins: true,
          enumerateDevices: true
        }
      }

      if (window.requestIdleCallback) {
        requestIdleCallback(function () {
          Fingerprint2.get(options, function (components) {
            console.log(components) // an array of components: {key: ..., value: ...}
            var values = components.map(function (component) {
              return component.value
            })
            var murmur = Fingerprint2.x64hash128(values.join(''), 31)
            console.log('murmur', murmur)
            window.localStorage.setItem('mobile_device_id', murmur)
          })
        })
      } else {
        setTimeout(function () {
          Fingerprint2.get(options, function (components) {
            console.log(components) // an array of components: {key: ..., value: ...}
            var values = components.map(function (component) {
              return component.value
            })
            var murmur = Fingerprint2.x64hash128(values.join(''), 31)
            console.log('murmur', murmur)
            window.localStorage.setItem('mobile_device_id', murmur)
          })
        }, 500)
      }
    },

    requestAccess() {
      axios({
        method: 'post',
        url: `/auth/collection_points/device_sign_in`,
        params: {
          device_id: window.localStorage.getItem('device_id')
        }
      })
        .then((response) => {
          console.log('response', response)
          // if (response.status == 200) {
          //   window.localStorage.setItem(
          //     "support_session_token",
          //     response.data.token
          //   );
          //   this.$router.push("/support");
          // }
        })
        .catch((error) => {
          let authError = Object.values(error.response.data.errors)[0][0]

          if (authError == 'Incomplete credentials') {
            this.$errorHumanized(null, this.$t('error.fillPin'))
          } else if (authError == 'Bad credentials') {
            this.$errorHumanized(null, this.$t('error.wrongPin'))
          } else {
            this.$errorHumanized(error)
          }
        })
    },
    click() {
      console.log('click')
      this.type = 'click'
    },
    touchHandler() {
      console.log('touchHandler')
      this.type = 'touchHandler'
    },
    longtapHandler() {
      console.log('longtapHandler')
      this.type = 'longtapHandler'
    },
    startHandler() {
      console.log('startHandler')
      this.type = 'startHandler'
    },
    movedHandler() {
      console.log('movedHandler')
      this.type = 'movedHandler'
    },
    touchHoldHandler() {
      console.log('touchHoldHandler')
      this.type = 'touchHoldHandler'
    },

    nativeClickHandler() {
      this.nativeEventsWoPrevent = 'click'
    },
    nativeStartHandler() {
      this.nativeEventsWoPrevent = 'startHandler'
    },
    nativeMovedHandler() {
      this.nativeEventsWoPrevent = 'movedHandler'
    },
    nativeEndHandler() {
      this.nativeEventsWoPrevent = 'endHandler'
    },

    nativeClickHandlerWithStop() {
      this.nativeEventsWithPrevent = 'click'
    },
    nativeStartHandlerWithStop() {
      this.nativeEventsWithPrevent = 'startHandler'
    },
    nativeMovedHandlerWithStop() {
      this.nativeEventsWithPrevent = 'movedHandler'
    },
    nativeEndHandlerWithStop() {
      this.nativeEventsWithPrevent = 'endHandler'
    },

    increment() {
      this.number++
    }
  }
}
